export default __webpack_public_path__ + "assets/icons/chevron-right.547531ac.svg";